import 'core-js/fn/promise'

import React from 'react'
import { find } from 'lodash'
import { ButtonToolbar } from 'react-bootstrap'

import * as scoreService from '../../services/score-service'
import * as scanService from '../../services/scan-service'
import * as unitService from '../../services/organizational-units-service'
import * as location from '../../services/location-service'

import Topbar from '../Topbar'
import ScanInfo from './components/ScanInfo'
import AnalysisQuestions from './components/AnalysisQuestions'
import { analysisPdfPrintExtended } from '../../utils/pdf.js'
import DownloadPdf from '../../components/DownloadPdf'

export default class Analysis extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.handleLocationChange = this.handleLocationChange.bind(this)
    this.handleUnitChange = this.handleUnitChange.bind(this)
    this.getUnitsForLocation = this.getUnitsForLocation.bind(this)
    this.initializeAnalysisScan = this.initializeAnalysisScan.bind(this)
    this.answerChanged = this.answerChanged.bind(this)
    this.setMode = this.setMode.bind(this)
    this.retrieveScores = this.retrieveScores.bind(this)
    this.getScoresForRecentScan = this.getScoresForRecentScan.bind(this)
    this.analysisPdfPrintExtended = analysisPdfPrintExtended.bind(this)

    this.state = {
      unit: undefined,
      location: undefined,
      units: [],
      locations: [],
      scan: undefined,
      wheelTotals: [],
      phaseTotals: [],
      analysisScan: undefined,
      mode: 'start',
      filter: '',
    }
  }
  
  setMode(mode, filter) {
    this.setState({mode: mode, filter: filter})
  }

  getScoresForRecentScan(unit) {
    scanService.getMostRecentCompletedScan(unit.id).then((scan) => {
      this.setState({scan: scan, unit: unit}, this.initializeAnalysisScan(scan, unit.id))
    }).catch(this.setState({scan: undefined, unit: unit, analysisScan: undefined}))
  }

  initializeAnalysisScan(scan, unitId) {
    if (scan && unitId) {
      console.log('Init analysis scan for scan: ' + scan.id)
      scanService
          .startScan({
            organizationalUnitId: unitId,
            id: scan.id,
            questionnaireId: scan.questionnaireId,
            analysisScan: true,
          })
          .then((response) => {
            console.log('Created analysis scan: ' + response.data.id)
            this.retrieveScores(response.data.id)
          })
    }
  }

  retrieveScores(scanId) {
    console.log('Calculating scores')
    scanService.calculateScan(scanId).then((scan) => {
      Promise.all([
        scoreService.getPhaseTotals(scan.id),
        scoreService.getSteeringWheelTotals(scan.id),
      ]).then(([phaseTotals, wheelTotals]) => {
        this.setState({ analysisScan: scan, phaseTotals, wheelTotals })
        window.sessionStorage.setItem('scores', JSON.stringify(this.state))
      })
    })
  }

  answerChanged() {
    if (this.state.analysisScan && this.state.unit) {
      this.retrieveScores(this.state.analysisScan.id, this.state.unit.id)
    }
  }

  clearScores() {
    this.setState({analysisScan: undefined, matrix: [], phaseTotals: [], wheelTotals: []})
  }

  componentDidMount() {
    location.getLocations().then((locations) => {
      this.setState({ locations: locations }, () => {
        if (this.props.match.params.scanId) {
          localStorage.removeItem('selectedLocation')
          localStorage.removeItem('selectedUnit')

          scanService.getScanById(this.props.match.params.scanId).then((scan) => {
            const location = find(
                this.state.locations,
                (loc) => loc.name === scan.locationName
            )
            unitService.getUnitsByLocation(location.id).then((units) => {
              const unit = find(units, (u) => u.id === scan.organizationalUnitId)
              this.setState({ scan, unit, units, location }, () =>
                  this.getScoresForRecentScan(unit)
              )
            })
          })
        } else {
          const savedLocation = localStorage.getItem('selectedLocation')
          const savedUnit = localStorage.getItem('selectedUnit')
          if (savedLocation && savedUnit) {
            const location = JSON.parse(savedLocation)
            const unit = JSON.parse(savedUnit)
            this.setState({ location, unit }, () => {
              unitService.getUnitsByLocation(location.id).then((units) => {
                this.setState({ units }, () =>
                    this.getScoresForRecentScan(unit)
                )
              })
            })
          }
        }
      })
    })
  }

  componentWillReceiveProps(nextProps) {
    this.clearScores()
    this.setState( {
      unit: undefined,
      location: undefined,
    })

    if (nextProps.match.params.scanId) {
      localStorage.removeItem('selectedLocation')
      localStorage.removeItem('selectedUnit')
    }
  }

  getUnitsForLocation() {
    if (this.state.location) {
      unitService.getUnitsByLocation(this.state.location.id)
        .then(units => this.setState({ units: units, unit: undefined }))
        .catch(() => this.setState({ units: [], unit: undefined }))
    }
  }

  handleLocationChange(e) {
    this.setState({ location: e, lastselectedLocation: e }, () => {
      this.getUnitsForLocation()
      localStorage.setItem('selectedLocation', JSON.stringify(e))
    })
  }

  handleUnitChange(e) {
    this.setState({ unit: e }, () => {
      this.getScoresForRecentScan(e)
      localStorage.setItem('selectedUnit', JSON.stringify(e))
    })
  }

  render() {
    const {
      units,
      location,
      locations,
      scan,
      analysisScan,
      total,
      phaseTotals,
      wheelTotals,
      unit,
      mode,
      filter,
    } = this.state
    const currentUnit = this.state.unit

    return (
        <div className="content col-2 analysis">
          <div className="content-inner">
            <Topbar
                title="Analyse"
                select={true}
                locations={locations}
                location={location}
                units={units}
                unit={unit}
                disabled={false}
                unitChange={this.handleUnitChange}
                locationChange={this.handleLocationChange}
            />

            <div className="inner">
              <div className="inner-container">
                <div className="results-container row">
                  {analysisScan && (
                      <ScanInfo
                          analyse={true}
                          scan={analysisScan}
                          phaseTotals={phaseTotals}
                          wheelTotals={wheelTotals}
                          setMode={this.setMode}
                      />
                  )}
                  {!scan && unit && <h2>Geen afgeronde scans beschikbaar</h2>}
                  {scan && unit && !analysisScan && (
                      <h2>Analyse wordt voorbereid...</h2>
                  )}

                  {analysisScan && (
                      <AnalysisQuestions
                          scan={analysisScan}
                          originalScan={scan}
                          mode={mode}
                          setMode={this.setMode}
                          filter={filter}
                          total={total}
                          phaseTotals={phaseTotals}
                          wheelTotals={wheelTotals}
                          currentUnit={currentUnit}
                          answerChanged={this.answerChanged}
                      />
                  )}
                </div>
              </div>
            </div>

            <div id="action-buttons">
              <ButtonToolbar>
                {analysisScan && (
                    <DownloadPdf
                        text=""
                        title="Analyse downloaden"
                        textbtn="Download (PDF)"
                        type="analysis"
                        buttonstyle="primary"
                    />
                )}
              </ButtonToolbar>
            </div>
          </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Analysis/index.js